// extracted by mini-css-extract-plugin
module.exports = {"title":"SizeGuideDialog_title__5bn8V","loading":"SizeGuideDialog_loading__wQiCM"};